import { createReducer } from "reduxsauce";

import importer from "common/importer";

const { INITIAL_STATE } = importer("Stores/Centers/InitialState", null);
const { CentersTypes } = importer("Stores/Centers/Actions", null);

const getAllCentersLoading = (state) => ({
  ...state,
  getAllCentersLoading: true,
  getAllCentersSuccess: null,
  getAllCentersFailure: null,
});
const getAllCentersSuccess = (state, { res }) => ({
  ...state,
  centers: res,
  getAllCentersLoading: false,
  getAllCentersSuccess: res,
  getAllCentersFailure: null,
});
const getAllCentersFailure = (state, { error }) => ({
  ...state,
  getAllCentersLoading: false,
  getAllCentersSuccess: null,
  getAllCentersFailure: error,
});

const getStateCentersLoading = (state) => ({
  ...state,
  getStateCentersLoading: true,
  getStateCentersSuccess: null,
  getStateCentersFailure: null,
});
const getStateCentersSuccess = (state, { res }) => ({
  ...state,
  getStateCentersLoading: false,
  getStateCentersSuccess: res,
  getStateCentersFailure: null,
});
const getStateCentersFailure = (state, { error }) => ({
  ...state,
  getStateCentersLoading: false,
  getStateCentersSuccess: null,
  getStateCentersFailure: error,
});

const getAppointmentCenterLoading = (state) => ({
  ...state,
  getAppointmentCenterLoading: true,
  getAppointmentCenterSuccess: null,
  getAppointmentCenterFailure: null,
});
const getAppointmentCenterSuccess = (state, { res }) => ({
  ...state,
  getAppointmentCenterLoading: false,
  getAppointmentCenterSuccess: res,
  getAppointmentCenterFailure: null,
});
const getAppointmentCenterFailure = (state, { error }) => ({
  ...state,
  getAppointmentCenterLoading: false,
  getAppointmentCenterSuccess: null,
  getAppointmentCenterFailure: error,
});

const getDonorCentersAllLoading = (state) => ({
  ...state,
  getDonorCentersAllLoading: true,
  getDonorCentersAllSuccess: null,
  getDonorCentersAllFailure: null,
});
const getDonorCentersAllSuccess = (state, { res }) => ({
  ...state,
  donorCenters: res,
  getDonorCentersAllLoading: false,
  getDonorCentersAllSuccess: res,
  getDonorCentersAllFailure: null,
});
const getDonorCentersAllFailure = (state, { error }) => ({
  ...state,
  getDonorCentersAllLoading: false,
  getDonorCentersAllSuccess: null,
  getDonorCentersAllFailure: error,
});

const getZipcodeSearchCentersLoading = (state, { error }) => ({
  ...state,
  getZipcodeSearchCentersLoading: true,
  getZipcodeSearchCentersSuccess: null,
  getZipcodeSearchCentersFailure: error,
});

const getZipcodeSearchCentersSuccess = (state, { res }) => ({
  ...state,
  getZipcodeSearchCentersLoading: false,
  getZipcodeSearchCentersSuccess: res,
  getZipcodeSearchCentersFailure: null,
});

const getZipcodeSearchCentersFailure = (state, { error }) => ({
  ...state,
  getZipcodeSearchCentersLoading: false,
  getZipcodeSearchCentersSuccess: null,
  getZipcodeSearchCentersFailure: error,
});

const getAppointmentSlotLoading = (state) => ({
  ...state,
  getAppointmentSlotLoading: true,
  getAppointmentSlotSuccess: null,
  getAppointmentSlotFailure: null,
});
const getAppointmentSlotSuccess = (state, { res }) => ({
  ...state,
  appointmentSlot: res,
  getAppointmentSlotLoading: false,
  getAppointmentSlotSuccess: res,
  getAppointmentSlotFailure: null,
});
const getAppointmentSlotFailure = (state, { error }) => ({
  ...state,
  getAppointmentSlotLoading: false,
  getAppointmentSlotSuccess: null,
  getAppointmentSlotFailure: error,
});

const addAppointmentSlotLoading = (state) => ({
  ...state,
  addAppointmentSlotLoading: true,
  addAppointmentSlotSuccess: null,
  addAppointmentSlotFailure: null,
});
const addAppointmentSlotSuccess = (state, { res }) => ({
  ...state,
  addAppointmentSlotLoading: false,
  addAppointmentSlotSuccess: res,
  addAppointmentSlotFailure: null,
});
const addAppointmentSlotFailure = (state, { error }) => ({
  ...state,
  addAppointmentSlotLoading: false,
  addAppointmentSlotSuccess: null,
  addAppointmentSlotFailure: error,
});

const getSlotsForAppointmentTypeLoading = (state) => ({
  ...state,
  getSlotsForAppointmentTypeLoading: true,
  getSlotsForAppointmentTypeSuccess: null,
  getSlotsForAppointmentTypeFailure: null,
});
const getSlotsForAppointmentTypeSuccess = (state, { res }) => ({
  ...state,
  slotsForAppointment: res,
  getSlotsForAppointmentTypeLoading: false,
  getSlotsForAppointmentTypeSuccess: res,
  getSlotsForAppointmentTypeFailure: null,
});
const getSlotsForAppointmentTypeFailure = (state, { error }) => ({
  ...state,
  getSlotsForAppointmentTypeLoading: false,
  getSlotsForAppointmentTypeSuccess: null,
  getSlotsForAppointmentTypeFailure: error,
});

const getSlotsForDonorLoading = (state) => ({
  ...state,
  getSlotsForDonorLoading: true,
  getSlotsForDonorSuccess: null,
  getSlotsForDonorFailure: null,
});
const getSlotsForDonorSuccess = (state, { res }) => ({
  ...state,
  slotsForDonor: res,
  getSlotsForDonorLoading: false,
  getSlotsForDonorSuccess: res,
  getSlotsForDonorFailure: null,
});
const getSlotsForDonorFailure = (state, { error }) => ({
  ...state,
  getSlotsForDonorLoading: false,
  getSlotsForDonorSuccess: null,
  getSlotsForDonorFailure: error,
});

/* NEW */

const getAppointmentReportLoading = (state) => ({
  ...state,
  getAppointmentReportLoading: true,
  getAppointmentReportSuccess: null,
  getAppointmentReportFailure: null,
});
const getAppointmentReportSuccess = (state, { res }) => ({
  ...state,
  getAppointmentReportLoading: false,
  getAppointmentReportSuccess: res,
  getAppointmentReportFailure: null,
});
const getAppointmentReportFailure = (state, { error }) => ({
  ...state,
  getAppointmentReportLoading: false,
  getAppointmentReportSuccess: null,
  getAppointmentReportFailure: error,
});

//

const downloadReportLoading = (state) => ({
  ...state,
  downloadReportLoading: true,
  downloadReportSuccess: null,
  downloadReportFailure: null,
});
const downloadReportSuccess = (state, { res }) => ({
  ...state,
  downloadReportLoading: false,
  downloadReportSuccess: res,
  downloadReportFailure: null,
});
const downloadReportFailure = (state, { error }) => ({
  ...state,
  downloadReportLoading: false,
  downloadReportSuccess: null,
  downloadReportFailure: error,
});

const getCenterCalendarLoading = (state) => ({
  ...state,
  getCenterCalendarLoading: true,
  getCenterCalendarSuccess: null,
  getCenterCalendarFailure: null,
});

const getCenterCalendarSuccess = (state, { res }) => ({
  ...state,
  getCenterCalendarLoading: false,
  getCenterCalendarSuccess: res,
  getCenterCalendarFailure: null,
});

const getCenterCalendarFailure = (state, { error }) => ({
  ...state,
  getCenterCalendarLoading: false,
  getCenterCalendarSuccess: null,
  getCenterCalendarFailure: error,
});

const getCenterSlotConfigLoading = (state) => ({
  ...state,
  getCenterSlotConfigLoading: true,
  getCenterSlotConfigSuccess: null,
  getCenterSlotConfigFailure: null,
});

const getCenterSlotConfigSuccess = (state, { res }) => ({
  ...state,
  getCenterSlotConfigLoading: false,
  getCenterSlotConfigSuccess: res,
  getCenterSlotConfigFailure: null,
});

const getCenterSlotConfigFailure = (state, { error }) => ({
  ...state,
  getCenterSlotConfigLoading: false,
  getCenterSlotConfigSuccess: null,
  getCenterSlotConfigFailure: error,
});

const saveCenterSlotConfigLoading = (state) => ({
  ...state,
  saveCenterSlotConfigLoading: true,
  saveCenterSlotConfigSuccess: null,
  saveCenterSlotConfigFailure: null,
});

const saveCenterSlotConfigSuccess = (state, { res }) => ({
  ...state,
  saveCenterSlotConfigLoading: false,
  saveCenterSlotConfigSuccess: res,
  saveCenterSlotConfigFailure: null,
});

const saveCenterSlotConfigFailure = (state, { error }) => ({
  ...state,
  saveCenterSlotConfigLoading: false,
  saveCenterSlotConfigSuccess: null,
  saveCenterSlotConfigFailure: error,
});

const registerGetCentersClear = (state) => ({
  ...state,
  registerGetCentersLoading: false,
  registerGetCentersSuccess: null,
  registerGetCentersFailure: null,
});
const registerGetCentersLoading = (state) => ({
  ...state,
  registerGetCentersLoading: true,
  registerGetCentersSuccess: null,
  registerGetCentersFailure: null,
});
const registerGetCentersSuccess = (state, { res }) => ({
  ...state,
  registerGetCentersLoading: false,
  registerGetCentersSuccess: res,
  registerGetCentersFailure: null,
});
const registerGetCentersFailure = (state, { error }) => ({
  ...state,
  registerGetCentersLoading: false,
  registerGetCentersSuccess: null,
  registerGetCentersFailure: error,
});

const cleanCentersState = (state) => ({
  ...state,
  centers: null,
  searchCenters: null,
  donorCenters: null,
  selectedCenters: null,
  appointmentSlot: null,
  slotsForDonor: null,
  nearbyCenters: null,
  centerStatus: null,
  slotsForAppointment: null,
  getAllCentersSuccess: null,
  searchCentersSuccess: null,
  getDonorCentersAllSuccess: null,
  getAppointmentSlotSuccess: null,
  addAppointmentSlotSuccess: null,
  getSlotsForAppointmentTypeSuccess: null,
  getSlotsForDonorSuccess: null,
  getAppointmentReportSuccess: null,
  downloadReportSuccess: null,
  getDonorCenterInfoSuccess: null,
  getAlternateDonorCentersInfoSuccess: null,
  favouriteCenters: null,
  getFavoriteCenterInfoSuccess: null,
  updateFavoriteCenterSuccess: null,
});

const getDonorCenterInfoSuccess = (state, { res }) => ({
  ...state,
  nearbyCenters: res.data.nearbyCenters,
  centerStatus: res.data.selectionStatus,
  getDonorCenterInfoLoading: false,
  getDonorCenterInfoSuccess: res,
  getDonorCenterInfoFailure: null,
});

const getDonorCenterInfoFailure = (state, { error }) => ({
  ...state,
  getDonorCenterInfoLoading: false,
  getDonorCenterInfoSuccess: null,
  getDonorCenterInfoFailure: error,
});

const getDonorCenterInfoLoading = (state, { error }) => ({
  ...state,
  getDonorCenterInfoLoading: true,
  getDonorCenterInfoSuccess: null,
  getDonorCenterInfoFailure: null,
});

const getFavoriteCenterInfoSuccess = (state, { res }) => ({
  ...state,
  favouriteCenters: res.data.favouriteCenters,
  getFavoriteCenterInfoLoading: false,
  getFavoriteCenterInfoSuccess: res,
  getFavoriteCenterInfoFailure: null,
});
const updateFavoriteCenterSuccess = (state, { res }) => ({
  ...state,
  updateFavoriteCenterLoading: false,
  updateFavoriteCenterSuccess: res,
  updateFavoriteCenterFailure: null,
});
const updateFavoriteCenterFailure = (state, { error }) => ({
  ...state,
  updateFavoriteCenterLoading: false,
  updateFavoriteCenterSuccess: null,
  updateFavoriteCenterFailure: error,
});
const updateFavoriteCenterLoading = (state) => ({
  ...state,
  updateFavoriteCenterLoading: true,
  updateFavoriteCenterSuccess: null,
  updateFavoriteCenterFailure: null,
});

const getFavoriteCenterInfoFailure = (state, { error }) => ({
  ...state,
  getFavoriteCenterInfoLoading: false,
  getFavoriteCenterInfoSuccess: null,
  getFavoriteCenterInfoFailure: error,
});

const getFavoriteCenterInfoLoading = (state, { error }) => ({
  ...state,
  getFavoriteCenterInfoLoading: true,
  getFavoriteCenterInfoSuccess: null,
  getFavoriteCenterInfoFailure: null,
});

const getAlternateDonorCentersInfoSuccess = (state, { res }) => ({
  ...state,
  getAlternateDonorCentersInfoLoading: false,
  getAlternateDonorCentersInfoSuccess: res,
  getAlternateDonorCentersInfoFailure: null,
});

const getAlternateDonorCentersInfoFailure = (state, { error }) => ({
  ...state,
  getAlternateDonorCentersInfoLoading: false,
  getAlternateDonorCentersInfoSuccess: null,
  getAlternateDonorCentersInfoFailure: error,
});

const getAlternateDonorCentersInfoLoading = (state, { error }) => ({
  ...state,
  getAlternateDonorCentersInfoLoading: true,
  getAlternateDonorCentersInfoSuccess: null,
  getAlternateDonorCentersInfoFailure: null,
});

const getCenterInfoSuccess = (state, { res }) => ({
  ...state,
  getCenterInfoLoading: false,
  getCenterInfoSuccess: res,
  getCenterInfoFailure: null,
});

const getCenterInfoFailure = (state, { error }) => ({
  ...state,
  getCenterInfoLoading: false,
  getCenterInfoSuccess: null,
  getCenterInfoFailure: error,
});

const getCenterInfoLoading = (state, { error }) => ({
  ...state,
  getCenterInfoLoading: true,
  getCenterInfoSuccess: null,
  getCenterInfoFailure: null,
});

const createApplicationUserSuccess = (state, { res }) => ({
  ...state,
  createApplicationUserLoading: false,
  createApplicationUserSuccess: res,
  createApplicationUserFailure: null,
});

const createApplicationUserFailure = (state, { error }) => ({
  ...state,
  createApplicationUserLoading: false,
  createApplicationUserSuccess: null,
  createApplicationUserFailure: error,
});

const createApplicationUserLoading = (state, { error }) => ({
  ...state,
  createApplicationUserLoading: true,
  createApplicationUserSuccess: null,
  createApplicationUserFailure: null,
});

const searchApplicationUserSuccess = (state, { res }) => ({
  ...state,
  searchApplicationUserLoading: false,
  searchApplicationUserSuccess: res,
  searchApplicationUserFailure: null,
});

const searchApplicationUserFailure = (state, { error }) => ({
  ...state,
  searchApplicationUserLoading: false,
  searchApplicationUserSuccess: null,
  searchApplicationUserFailure: error,
});

const searchApplicationUserLoading = (state, { error }) => ({
  ...state,
  searchApplicationUserLoading: true,
  searchApplicationUserSuccess: null,
  searchApplicationUserFailure: null,
});

const getApplicationUserDetailsSuccess = (state, { res }) => ({
  ...state,
  getApplicationUserDetailsLoading: false,
  getApplicationUserDetailsSuccess: res,
  getApplicationUserDetailsFailure: null,
});

const getApplicationUserDetailsFailure = (state, { error }) => ({
  ...state,
  getApplicationUserDetailsLoading: false,
  getApplicationUserDetailsSuccess: null,
  getApplicationUserDetailsFailure: error,
});

const getApplicationUserDetailsLoading = (state, { error }) => ({
  ...state,
  getApplicationUserDetailsLoading: true,
  getApplicationUserDetailsSuccess: null,
  getApplicationUserDetailsFailure: null,
});

const editApplicationUserSuccess = (state, { res }) => ({
  ...state,
  editApplicationUserLoading: false,
  editApplicationUserSuccess: res,
  editApplicationUserFailure: null,
});

const editApplicationUserFailure = (state, { error }) => ({
  ...state,
  editApplicationUserLoading: false,
  editApplicationUserSuccess: null,
  editApplicationUserFailure: error,
});

const editApplicationUserLoading = (state, { error }) => ({
  ...state,
  editApplicationUserLoading: true,
  editApplicationUserSuccess: null,
  editApplicationUserFailure: null,
});

const removeUserCenterAccessSuccess = (state, { res }) => ({
  ...state,
  removeUserCenterAccessLoading: false,
  removeUserCenterAccessSuccess: res,
  removeUserCenterAccessFailure: null,
});

const removeUserCenterAccessFailure = (state, { error }) => ({
  ...state,
  removeUserCenterAccessLoading: false,
  removeUserCenterAccessSuccess: null,
  removeUserCenterAccessFailure: error,
});

const removeUserCenterAccessLoading = (state, { error }) => ({
  ...state,
  removeUserCenterAccessLoading: true,
  removeUserCenterAccessSuccess: null,
  removeUserCenterAccessFailure: null,
});

const updateUserDefaultCenterSuccess = (state, { res }) => ({
  ...state,
  updateUserDefaultCenterLoading: false,
  updateUserDefaultCenterSuccess: res,
  updateUserDefaultCenterFailure: null,
});

const updateUserDefaultCenterFailure = (state, { error }) => ({
  ...state,
  updateUserDefaultCenterLoading: false,
  updateUserDefaultCenterSuccess: null,
  updateUserDefaultCenterFailure: error,
});

const updateUserDefaultCenterLoading = (state, { error }) => ({
  ...state,
  updateUserDefaultCenterLoading: true,
  updateUserDefaultCenterSuccess: null,
  updateUserDefaultCenterFailure: null,
});

const removeUserPortalAccessSuccess = (state, { res }) => ({
  ...state,
  removeUserPortalAccessLoading: false,
  removeUserPortalAccessSuccess: res,
  removeUserPortalAccessFailure: null,
});

const removeUserPortalAccessFailure = (state, { error }) => ({
  ...state,
  removeUserPortalAccessLoading: false,
  removeUserPortalAccessSuccess: null,
  removeUserPortalAccessFailure: error,
});

const removeUserPortalAccessLoading = (state, { error }) => ({
  ...state,
  removeUserPortalAccessLoading: true,
  removeUserPortalAccessSuccess: null,
  removeUserPortalAccessFailure: null,
});

const addUserCenterAccessSuccess = (state, { res }) => ({
  ...state,
  addUserCenterAccessLoading: false,
  addUserCenterAccessSuccess: res,
  addUserCenterAccessFailure: null,
});

const addUserCenterAccessFailure = (state, { error }) => ({
  ...state,
  addUserCenterAccessLoading: false,
  addUserCenterAccessSuccess: null,
  addUserCenterAccessFailure: error,
});

const addUserCenterAccessLoading = (state, { error }) => ({
  ...state,
  addUserCenterAccessLoading: true,
  addUserCenterAccessSuccess: null,
  addUserCenterAccessFailure: null,
});

export const reducer = createReducer(INITIAL_STATE, {
  [CentersTypes.GET_ALL_CENTERS_LOADING]: getAllCentersLoading,
  [CentersTypes.GET_ALL_CENTERS_SUCCESS]: getAllCentersSuccess,
  [CentersTypes.GET_ALL_CENTERS_FAILURE]: getAllCentersFailure,

  [CentersTypes.GET_APPOINTMENT_CENTER_LOADING]: getAppointmentCenterLoading,
  [CentersTypes.GET_APPOINTMENT_CENTER_SUCCESS]: getAppointmentCenterSuccess,
  [CentersTypes.GET_APPOINTMENT_CENTER_FAILURE]: getAppointmentCenterFailure,

  [CentersTypes.GET_DONOR_CENTER_INFO_LOADING]: getDonorCenterInfoLoading,
  [CentersTypes.GET_DONOR_CENTER_INFO_SUCCESS]: getDonorCenterInfoSuccess,
  [CentersTypes.GET_DONOR_CENTER_INFO_FAILURE]: getDonorCenterInfoFailure,

  [CentersTypes.GET_FAVORITE_CENTER_INFO_LOADING]: getFavoriteCenterInfoLoading,
  [CentersTypes.GET_FAVORITE_CENTER_INFO_SUCCESS]: getFavoriteCenterInfoSuccess,
  [CentersTypes.GET_FAVORITE_CENTER_INFO_FAILURE]: getFavoriteCenterInfoFailure,

  [CentersTypes.UPDATE_FAVORITE_CENTER_LOADING]: updateFavoriteCenterLoading,
  [CentersTypes.UPDATE_FAVORITE_CENTER_SUCCESS]: updateFavoriteCenterSuccess,
  [CentersTypes.UPDATE_FAVORITE_CENTER_FAILURE]: updateFavoriteCenterFailure,

  [CentersTypes.GET_ALTERNATE_DONOR_CENTERS_INFO_LOADING]:
    getAlternateDonorCentersInfoLoading,
  [CentersTypes.GET_ALTERNATE_DONOR_CENTERS_INFO_SUCCESS]:
    getAlternateDonorCentersInfoSuccess,
  [CentersTypes.GET_ALTERNATE_DONOR_CENTERS_INFO_FAILURE]:
    getAlternateDonorCentersInfoFailure,

  [CentersTypes.GET_CENTER_INFO_LOADING]: getCenterInfoLoading,
  [CentersTypes.GET_CENTER_INFO_SUCCESS]: getCenterInfoSuccess,
  [CentersTypes.GET_CENTER_INFO_FAILURE]: getCenterInfoFailure,

  [CentersTypes.GET_DONOR_CENTERS_ALL_LOADING]: getDonorCentersAllLoading,
  [CentersTypes.GET_DONOR_CENTERS_ALL_SUCCESS]: getDonorCentersAllSuccess,
  [CentersTypes.GET_DONOR_CENTERS_ALL_FAILURE]: getDonorCentersAllFailure,

  [CentersTypes.GET_STATE_CENTERS_LOADING]: getStateCentersLoading,
  [CentersTypes.GET_STATE_CENTERS_SUCCESS]: getStateCentersSuccess,
  [CentersTypes.GET_STATE_CENTERS_FAILURE]: getStateCentersFailure,

  [CentersTypes.GET_ZIPCODE_SEARCH_CENTERS_LOADING]:
    getZipcodeSearchCentersLoading,
  [CentersTypes.GET_ZIPCODE_SEARCH_CENTERS_SUCCESS]:
    getZipcodeSearchCentersSuccess,
  [CentersTypes.GET_ZIPCODE_SEARCH_CENTERS_FAILURE]:
    getZipcodeSearchCentersFailure,

  [CentersTypes.GET_APPOINTMENT_SLOT_LOADING]: getAppointmentSlotLoading,
  [CentersTypes.GET_APPOINTMENT_SLOT_SUCCESS]: getAppointmentSlotSuccess,
  [CentersTypes.GET_APPOINTMENT_SLOT_FAILURE]: getAppointmentSlotFailure,

  [CentersTypes.ADD_APPOINTMENT_SLOT_LOADING]: addAppointmentSlotLoading,
  [CentersTypes.ADD_APPOINTMENT_SLOT_SUCCESS]: addAppointmentSlotSuccess,
  [CentersTypes.ADD_APPOINTMENT_SLOT_FAILURE]: addAppointmentSlotFailure,

  [CentersTypes.GET_SLOTS_FOR_APPOINTMENT_TYPE_LOADING]:
    getSlotsForAppointmentTypeLoading,
  [CentersTypes.GET_SLOTS_FOR_APPOINTMENT_TYPE_SUCCESS]:
    getSlotsForAppointmentTypeSuccess,
  [CentersTypes.GET_SLOTS_FOR_APPOINTMENT_TYPE_FAILURE]:
    getSlotsForAppointmentTypeFailure,

  [CentersTypes.GET_SLOTS_FOR_DONOR_LOADING]: getSlotsForDonorLoading,
  [CentersTypes.GET_SLOTS_FOR_DONOR_SUCCESS]: getSlotsForDonorSuccess,
  [CentersTypes.GET_SLOTS_FOR_DONOR_FAILURE]: getSlotsForDonorFailure,

  // NEW

  [CentersTypes.REGISTER_GET_CENTERS_CLEAR]: registerGetCentersClear,
  [CentersTypes.REGISTER_GET_CENTERS_LOADING]: registerGetCentersLoading,
  [CentersTypes.REGISTER_GET_CENTERS_SUCCESS]: registerGetCentersSuccess,
  [CentersTypes.REGISTER_GET_CENTERS_FAILURE]: registerGetCentersFailure,

  [CentersTypes.GET_APPOINTMENT_REPORT_LOADING]: getAppointmentReportLoading,
  [CentersTypes.GET_APPOINTMENT_REPORT_SUCCESS]: getAppointmentReportSuccess,
  [CentersTypes.GET_APPOINTMENT_REPORT_FAILURE]: getAppointmentReportFailure,

  [CentersTypes.DOWNLOAD_REPORT_LOADING]: downloadReportLoading,
  [CentersTypes.DOWNLOAD_REPORT_SUCCESS]: downloadReportSuccess,
  [CentersTypes.DOWNLOAD_REPORT_FAILURE]: downloadReportFailure,

  [CentersTypes.GET_CENTER_CALENDAR_LOADING]: getCenterCalendarLoading,
  [CentersTypes.GET_CENTER_CALENDAR_SUCCESS]: getCenterCalendarSuccess,
  [CentersTypes.GET_CENTER_CALENDAR_FAILURE]: getCenterCalendarFailure,

  [CentersTypes.GET_CENTER_SLOT_CONFIG_LOADING]: getCenterSlotConfigLoading,
  [CentersTypes.GET_CENTER_SLOT_CONFIG_SUCCESS]: getCenterSlotConfigSuccess,
  [CentersTypes.GET_CENTER_SLOT_CONFIG_FAILURE]: getCenterSlotConfigFailure,

  [CentersTypes.SAVE_CENTER_SLOT_CONFIG_LOADING]: saveCenterSlotConfigLoading,
  [CentersTypes.SAVE_CENTER_SLOT_CONFIG_SUCCESS]: saveCenterSlotConfigSuccess,
  [CentersTypes.SAVE_CENTER_SLOT_CONFIG_FAILURE]: saveCenterSlotConfigFailure,

  [CentersTypes.CREATE_APPLICATION_USER_LOADING]: createApplicationUserLoading,
  [CentersTypes.CREATE_APPLICATION_USER_SUCCESS]: createApplicationUserSuccess,
  [CentersTypes.CREATE_APPLICATION_USER_FAILURE]: createApplicationUserFailure,

  [CentersTypes.SEARCH_APPLICATION_USER_LOADING]: searchApplicationUserLoading,
  [CentersTypes.SEARCH_APPLICATION_USER_SUCCESS]: searchApplicationUserSuccess,
  [CentersTypes.SEARCH_APPLICATION_USER_FAILURE]: searchApplicationUserFailure,

  [CentersTypes.GET_APPLICATION_USER_DETAILS_LOADING]:
    getApplicationUserDetailsLoading,
  [CentersTypes.GET_APPLICATION_USER_DETAILS_SUCCESS]:
    getApplicationUserDetailsSuccess,
  [CentersTypes.GET_APPLICATION_USER_DETAILS_FAILURE]:
    getApplicationUserDetailsFailure,

  [CentersTypes.EDIT_APPLICATION_USER_LOADING]: editApplicationUserLoading,
  [CentersTypes.EDIT_APPLICATION_USER_SUCCESS]: editApplicationUserSuccess,
  [CentersTypes.EDIT_APPLICATION_USER_FAILURE]: editApplicationUserFailure,

  [CentersTypes.REMOVE_USER_CENTER_ACCESS_LOADING]:
    removeUserCenterAccessLoading,
  [CentersTypes.REMOVE_USER_CENTER_ACCESS_SUCCESS]:
    removeUserCenterAccessSuccess,
  [CentersTypes.REMOVE_USER_CENTER_ACCESS_FAILURE]:
    removeUserCenterAccessFailure,

  [CentersTypes.UPDATE_USER_DEFAULT_CENTER_LOADING]:
    updateUserDefaultCenterLoading,
  [CentersTypes.UPDATE_USER_DEFAULT_CENTER_SUCCESS]:
    updateUserDefaultCenterSuccess,
  [CentersTypes.UPDATE_USER_DEFAULT_CENTER_FAILURE]:
    updateUserDefaultCenterFailure,

  [CentersTypes.REMOVE_USER_PORTAL_ACCESS_LOADING]:
    removeUserPortalAccessLoading,
  [CentersTypes.REMOVE_USER_PORTAL_ACCESS_SUCCESS]:
    removeUserPortalAccessSuccess,
  [CentersTypes.REMOVE_USER_PORTAL_ACCESS_FAILURE]:
    removeUserPortalAccessFailure,

  [CentersTypes.ADD_USER_CENTER_ACCESS_LOADING]: addUserCenterAccessLoading,
  [CentersTypes.ADD_USER_CENTER_ACCESS_SUCCESS]: addUserCenterAccessSuccess,
  [CentersTypes.ADD_USER_CENTER_ACCESS_FAILURE]: addUserCenterAccessFailure,

  [CentersTypes.CLEAN_CENTERS_STATE]: cleanCentersState,
});
